import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import DialogTitle from "@mui/material/DialogTitle";
import Checkbox from "@mui/material/Checkbox";

const SettingsFormControl = styled(FormControl)({
  "&.MuiFormControl-root": {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row"
  }
});

const Usersetting = styled("div")`
  flex: 1 50%;
  padding: 8px;
`;

const UsersettingTitle = styled("span")`
  font-size: 14px;
`;

const StyledButton = styled(Button)(({ theme }) => {
  return {
    "&:focus-visible": {
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

const StyledCheckbox = styled(Checkbox)(({ theme }) => {
  return {
    "&.MuiCheckbox-root": {
      "&.Mui-focusVisible": {
        outline: theme.outline(),
        outlineOffset: "-2px"
      }
    }
  };
});

const StyledRadio = styled(Radio)(({ theme }) => {
  return {
    "&.MuiRadio-root": {
      "&.Mui-focusVisible": {
        outline: theme.outline(),
        outlineOffset: "-2px"
      }
    }
  };
});

// TODO: UserSettings Navigation der Settingselemente testen (bisher nur "Speichern" Button)

function UsersettingsModal({ hideModal, usersettings, setUsersettings, kind }) {
  const [settings, setSettings] = useState(usersettings);

  function save() {
    setUsersettings(settings);
    hideModal();
  }

  function handleItemChange(settingLabel, itemLabel, itemActive) {
    const isActive = (setting, item) => {
      if (settingLabel === setting.label && setting.type === "singleselect") {
        return itemLabel === item.label;
      }
      return settingLabel === setting.label && itemLabel === item.label ? itemActive : item.active;
    };
    setSettings(
      settings.map(setting => ({
        ...setting,
        items: setting.items.map(item => ({
          ...item,
          active: isActive(setting, item)
        }))
      }))
    );
  }

  function renderSettingItems({ items, type, label }) {
    if (type === "multiselect") {
      return (
        <FormGroup>
          {items.map(item => (
            <FormControlLabel
              control={
                <StyledCheckbox
                  checked={item.active}
                  onChange={e => handleItemChange(label, item.label, e.target.checked)}
                  color="primary"
                  slotProps={{
                    input: {
                      "aria-label": item.label
                    }
                  }}
                />
              }
              key={item.label}
              label={item.label}
            />
          ))}
        </FormGroup>
      );
    }
    if (type === "singleselect") {
      const selectedOption = items.find(item => item.active) || {};
      return (
        <RadioGroup
          aria-label={label}
          value={selectedOption.label}
          onChange={e => handleItemChange(label, e.target.value)}
        >
          {items.map(item => (
            <FormControlLabel
              key={item.label}
              label={item.label}
              value={item.label}
              control={<StyledRadio color="secondary" />}
            />
          ))}
        </RadioGroup>
      );
    }
  }

  return (
    <>
      <DialogTitle id={`${kind}-modal-title`}>Material-Einstellungen</DialogTitle>
      <DialogContent>
        <SettingsFormControl>
          {settings.map(setting => (
            <Usersetting key={setting.label}>
              <UsersettingTitle>{setting.label}</UsersettingTitle>
              {renderSettingItems(setting)}
            </Usersetting>
          ))}
        </SettingsFormControl>
      </DialogContent>
      <DialogActions>
        <StyledButton color="primary" variant="text" onClick={save}>
          Speichern
        </StyledButton>
      </DialogActions>
    </>
  );
}

UsersettingsModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  usersettings: PropTypes.array.isRequired,
  setUsersettings: PropTypes.func.isRequired,
  kind: PropTypes.string.isRequired
};

export default UsersettingsModal;
